export enum DocTemplateType {
  PROPOSAL = 'proposal',
  LETTER = 'letter',
  POLICY = 'policy',
  CONTRACT = 'contract',
}

export enum EventCategory {
  CORE_BEHAVIOR = 'core_behavior',
  SIGNUP_CONVERSION = 'signup_conversion',
  RECIPIENT_ENGAGEMENT = 'recipient_engagement',
  RETURN_BEHAVIOR = 'return_behavior',
}

export enum EventName {
  DOCUMENT_UPLOADED = 'document_uploaded',
  TEMPLATE_OPENED = 'template_opened',
  BLANK_DOC = 'blank_doc',
  EDITOR_LOADED = 'editor_loaded',
  EDITOR_EDITED = 'editor_edited',
  AI_TOOL_USED = 'ai_tool_used',
  REVIEW_INITIATED = 'review_initiated',
  SAVE_ATTEMPTED = 'save_attempted',
  SAVE_SUCCESSFUL = 'save_successful',
  SEND_ATTEMPTED = 'send_attempted',
  SEND_COMPLETED = 'send_completed',
  DOWNLOAD_ATTEMPTED = 'download_attempted',
  DOWNLOAD_COMPLETED = 'download_completed',
  DOC_COMPLETED = 'doc_completed',
  SIGNUP_COMPLETED = 'signup_completed',
  SIGNUP_SOURCE = 'signup_source',
  DOC_VIEWED_BY_RECIPIENT = 'doc_viewed_by_recipient',
  COMMENT_ADDED_BY_RECIPIENT = 'comment_added_by_recipient',
  RECIPIENT_DOWNLOADED_DOC = 'recipient_downloaded_doc',
  DOC_REOPENED_BY_USER = 'doc_reopened_by_user',
  DOC_SAVED_MULTIPLE_TIMES = 'doc_saved_multiple_times',
  MULTIPLE_DOCS_CREATED = 'multiple_docs_created',
}

export interface Event {
  // auto generated
  id: number
  created_at: string
  user_id: string

  // required
  category: EventCategory
  name: EventName

  // optional, but better to be provided
  doc_template_type?: DocTemplateType
  doc_public_id?: string

  // optional
  source?: string // eg, signup source: save/send/download or AI tool used: apply improvement, etc.
  meta?: Record<string, any>
}

export interface CreateEventPayload {
  category?: EventCategory
  name: EventName
  source?: string
  doc_template_type?: DocTemplateType
  doc_public_id?: string
  meta?: Record<string, any>
}

export interface EventResponse {
  event: Event
}

export interface DocTemplateData {
  templateId: string
  templateSlug: string
  templateName: string
  templateType: DocTemplateType
}
